if (!customElements.get('about-carousel')) {
  customElements.define(
    'about-carousel',
    class AboutCarousel extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.about-carousel__viewport');
        this.track = this.querySelector('.about-carousel__track');
        this.toggleButton = this.querySelector('.about-carousel__toggle');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.lastWidth = 0;
        if (!this.track || this.track.children.length === 0) return;

        this.toggleButton.addEventListener('click', () => this.setPaused(!this.classList.contains('is-paused')));
        // Hold still while a slide is selected in the theme editor
        this.addEventListener('shopify:block:select', () => this.classList.add('is-editor-paused'));
        this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-editor-paused'));
        this.reducedMotion.addEventListener('change', () => this.build());

        this.resizeObserver = new ResizeObserver(() => {
          if (this.viewport.clientWidth === this.lastWidth) return;
          this.lastWidth = this.viewport.clientWidth;
          this.build();
        });
        this.resizeObserver.observe(this.viewport);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      // Appends inert copies of the slides so the track can loop seamlessly
      // by translating exactly one set's width.
      build() {
        this.track.querySelectorAll('[data-clone]').forEach((clone) => clone.remove());
        this.classList.remove('is-animated');
        this.toggleButton.hidden = true;
        if (this.reducedMotion.matches) return;

        // Measure in the animated layout, which drops the static scroll padding
        this.classList.add('is-animated');
        const originals = Array.from(this.track.children);
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = this.track.scrollWidth + gap;
        if (distance <= gap) {
          this.classList.remove('is-animated');
          return;
        }

        const copies = Math.max(1, Math.ceil(this.viewport.clientWidth / distance));
        for (let i = 0; i < copies; i++) {
          originals.forEach((slide) => {
            const clone = slide.cloneNode(true);
            clone.setAttribute('data-clone', '');
            clone.setAttribute('aria-hidden', 'true');
            clone.removeAttribute('data-shopify-editor-block');
            clone.inert = true;
            this.track.appendChild(clone);
          });
        }

        const speed = parseFloat(this.dataset.speed) || 35;
        this.style.setProperty('--about-carousel-distance', `${distance}px`);
        this.style.setProperty('--about-carousel-duration', `${distance / speed}s`);
        this.toggleButton.hidden = false;
      }

      setPaused(paused) {
        this.classList.toggle('is-paused', paused);
        this.toggleButton.setAttribute(
          'aria-label',
          paused ? this.toggleButton.dataset.labelPlay : this.toggleButton.dataset.labelPause
        );
      }
    }
  );
}
